import commonMapping from "@/mapping/common";

const server_mode_list = [
  { id: "ntp_type1", value: "default", config: "default", label: "ntp_use_default" },
  { id: "ntp_type2", value: "manual", config: "manual", label: "ntp_use_manual" },
];

export const ntpSettings = {
  server_mode: server_mode_list,
  daylight_enable: commonMapping.intToBoolean,
};

export default ntpSettings;
